import { render, staticRenderFns } from "./DeleteQueueDialog.vue?vue&type=template&id=8c4bb46e"
import script from "./DeleteQueueDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQueueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports